import { CampaignsForAutocompleteQuery } from './__generated__/CampaignsForAutocompleteQuery';
import { useLazyQuery } from '@apollo/react-hooks';
import { CAMPAIGNS_WITH_OBJECTIVE_FOR_AUTOCOMPLETE_QUERY, kmsClient } from 'api';
import { CAMPAIGNS_FOR_AUTOCOMPLETE_QUERY } from './campaignsForAutocomplete.query';
import { CampaignsWithObjectiveForAutocompleteQuery } from './__generated__/CampaignsWithObjectiveForAutocompleteQuery';

export const useCampaignsForAutocompleteLazyQuery = () => {
  return useLazyQuery<CampaignsForAutocompleteQuery>(CAMPAIGNS_FOR_AUTOCOMPLETE_QUERY, {
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};

export const useCampaignsWithObjectiveForAutocompleteLazyQuery = () => {
  return useLazyQuery<CampaignsWithObjectiveForAutocompleteQuery>(CAMPAIGNS_WITH_OBJECTIVE_FOR_AUTOCOMPLETE_QUERY, {
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
